<template>
  <div id="login" align-h="center">
    <br />
    <br />
    <b-container style="min-width: 30rem; min-height: 45rem; padding: 5rem">
      <!-- <template v-slot:header> -->

      <!-- <b-card img-left
        ><b-img src="@/assets/seim-logo.png" style="max-height: 200px"
      /></b-card> -->
      <!-- </template> -->
      <b-row cols="3">
        <b-col></b-col>
        <b-col>
          <b-card
            class="text-center"
            bg-variant="light"
            title="Cost Benefit Analysis Tool"
            sub-title="School Infrastructure NSW"
          >
            <template v-slot:header>
              <!-- <b-img
            blank-color="rgb(50, 63, 72)"
            src="@/assets/seim-logo.png"
            style="max-height: 200px; margin-top: 0.8em"
          /> -->
            </template>
            <br />
            <b-card-text>Please enter the password to continue.</b-card-text>
            <b-form @submit.prevent="login">
              <b-input
                id="passwordInput"
                v-model="password"
                type="password"
                placeholder="enter password"
                required
              ></b-input>
              <br />

              <b-button variant="sgs-green" type="submit">
                Login as staff
              </b-button>
            </b-form>
            <!-- <template v-slot:footer> </template> -->
          </b-card>
          <br />
          <b-alert
            v-if="successMessage"
            class="text-center"
            variant="success"
            show
            >{{ successMessage }}</b-alert
          >
          <b-alert v-if="serverError" show variant="danger" class="text-center">
            {{ serverError }}
          </b-alert>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "login",
  props: {
    dataSuccessMessage: {
      type: String,
    },
  },
  data() {
    return {
      // username: '',
      // password: "CoffeeJambalaya100!",
      password: "",
      serverError: "",
      successMessage: this.dataSuccessMessage,
      loading: false,
    };
  },
  methods: {
    login() {
      this.loading = true;
      this.$store
        .dispatch("retrieveToken", {
          // username: this.username,
          password: this.password,
        })
        .then(() => {
          this.loading = false;
          localStorage.setItem("is_admin", true);
          this.$router.push({ name: "ProjectList" });
          // this.successMessage = response.data;
        })
        .catch((error) => {
          console.log(error.response.status);
          this.loading = false;
          this.serverError = error.response.data;
          this.password = "";
          this.successMessage = "";
        });
    },
  },
  mounted() {
    this.serverError = this.$route.params.error;
  },
};
</script>

<style scoped>
.server-error {
  color: red;
}

.card-header {
  background-color: rgb(50, 63, 72);
}
</style>
